import {z as zod} from "zod";

export type OttopilotExternalSourceWorkspaceCapabilityConfiguration = Record<string, never>;

export const ottopilotExternalSourceWorkspaceCapabilityConfigurationValidator: zod.ZodType<OttopilotExternalSourceWorkspaceCapabilityConfiguration> = zod.strictObject({});
